<div class="row">
  <div class="col-lg-2" style="background-color: #F2F2F2">
    <app-admin-menu></app-admin-menu>
  </div>
  <div class="col-lg-10" style="padding-top: 54px;">
    <div class="">
      <div class="admin-main-container-content">

        <div class="header-title-admin">{{'' | i18n: 'promotion-config'}}.</div>
        <div class="search-container">
          <div class="search-field">
            <button routerLink="/admin/promotion">{{'' | i18n: 'new-promotion'}}.</button>
          </div>
        </div>

        @if (promotionList) {
          <div class="form-row-container-prom">
            <div class="table-header-prom">
              <div class="table-header-item-status">
                <a (click)="orderBy('dateCreated')">{{'' | i18n: 'date-created'}}@if (filter.orderBy == 'dateCreated') {
                  <img
                    src="{{showDirectionImage()}}" alt="" class="sort-img"/>
                }</a>
              </div>
              <div class="table-header-item-status">
                <a (click)="orderBy('createdBy')">{{'' | i18n: 'created-by'}}@if (filter.orderBy == 'createdBy') {
                  <img
                    src="{{showDirectionImage()}}" alt=""
                    class="sort-img"/>
                }</a>
              </div>
              <div class="table-header-item-status">
                <a (click)="orderBy('contractType')">{{'' | i18n: 'warranty-type'}}@if (filter.orderBy == 'contractType') {
                  <img
                    src="{{showDirectionImage()}}" alt="" class="sort-img"/>
                }</a>
              </div>
              <div class="table-header-item-status">
                <a (click)="orderBy('contractCode')">{{'' | i18n: 'contract-code'}}@if (filter.orderBy == 'contractCode') {
                  <img
                    src="{{showDirectionImage()}}" alt="" class="sort-img"/>
                }</a>
              </div>
              <div class="table-header-item-status">
                <a (click)="orderBy('brand')">{{'' | i18n: 'brand'}}@if (filter.orderBy == 'brand') {
                  <img
                    src="{{showDirectionImage()}}" alt=""
                    class="sort-img"/>
                }</a>
              </div>
              <div class="table-header-item-status">
                <a (click)="orderBy('model')">{{'' | i18n: 'order-date-from'}}@if (filter.orderBy == 'model') {
                  <img
                    src="{{showDirectionImage()}}" alt=""
                    class="sort-img"/>
                }</a>
              </div>
              <div class="table-header-item-status">
                <a (click)="orderBy('contractType')">{{'' | i18n: 'order-date-to'}}@if (filter.orderBy == 'contractType') {
                  <img
                    src="{{showDirectionImage()}}" alt="" class="sort-img"/>
                }</a>
              </div>
              <div class="table-header-item-status">
                <a (click)="orderBy('contractCode')">{{'' | i18n: 'discount'}} %@if (filter.orderBy == 'contractCode') {
                  <img
                    src="{{showDirectionImage()}}" alt="" class="sort-img"/>
                }</a>
              </div>
              <div class="table-header-item-status">
                <a (click)="orderBy('warrantyNumber')">{{'' | i18n: 'dealer-regions'}}@if (filter.orderBy == 'warrantyNumber') {
                  <img
                    src="{{showDirectionImage()}}" alt="" class="sort-img"/>
                }</a>
              </div>
              <div class="table-header-item-status">
                <a (click)="orderBy('contractStartDate')">{{'' | i18n: 'dealers'}}@if (filter.orderBy == 'contractStartDate') {
                  <img
                    src="{{showDirectionImage()}}" alt=""
                    class="sort-img"/>
                }</a>
              </div>
              <div class="table-header-item-status">
                <a (click)="orderBy('contractEndDate')">{{'' | i18n: 'model-codes'}}@if (filter.orderBy == 'contractEndDate') {
                  <img
                    src="{{showDirectionImage()}}" alt="" class="sort-img"/>
                }</a>
              </div>
              <div class="table-header-item-status">
                <a (click)="orderBy('contractMileage')">{{'' | i18n: 'description'}}@if (filter.orderBy == 'contractMileage') {
                  <img
                    src="{{showDirectionImage()}}" alt="" class="sort-img"/>
                }</a>
              </div>
              <div class="table-header-item-status">
                <a>{{'' | i18n: 'landing-attachment'}}</a>
              </div>
              <div class="table-header-item-status">
                <a>{{'' | i18n: 'open'}}</a>
              </div>
            </div>
            @for (r of promotionList.dataList; track r) {
              <div class="table-list">
                <div class="table-list-item-status">{{ r.dateMade }}</div>
                <div class="table-list-item-status">{{ r.createdBy }}</div>
                @if (r.selectedContractType) {
                  <div
                  class="table-list-item-status">{{ r.selectedContractType.contractType }}</div>
                }
                @if (!r.selectedContractType) {
                  <div class="table-list-item-status">---</div>
                }
                @if (r.selectedContractCode) {
                  <div class="table-list-item-status">{{ r.selectedContractCode }}</div>
                }
                @if (!r.selectedContractCode) {
                  <div class="table-list-item-status">---</div>
                }
                <div class="table-list-item-status ellipsis">{{ r.selectedBrand }}</div>
                <div class="table-list-item-status ellipsis">{{ r.dateFrom }}</div>
                <div class="table-list-item-status ellipsis">{{ r.dateTo }}</div>
                <div class="table-list-item-status ellipsis">{{ r.discount }}</div>
                <div class="table-list-item-status ellipsis">{{ r.selectedRegions }}</div>
                <div class="table-list-item-status ellipsis">{{ r.selectedDealers }}</div>
                <div class="table-list-item-status ellipsis">{{ r.selectedModels }}</div>
                <div class="table-list-item-status ellipsis" >{{ r.description }}</div>
                <div class="table-list-item-status ellipsis">
                  @for (d of r.documentUrls; track d) {
                    <a>
                      <i class="fa fa-paperclip" aria-hidden="true" (click)="downloadPromotionFile(r.id, d)"
                      style="margin-left: 10px"></i>
                    </a>
                  }
                </div>
                <div class="table-list-item-status"><a routerLink="/admin/promotion/{{r.id}}">{{'' | i18n: 'open'}}</a></div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
